import React from 'react';
import MiniTab from '../jo-components/misc/miniTab/miniTab';
import { OrderList } from './components/orderList';
import { WaitingTicketsList } from './components/waitingTicketsList';
import './homeStep.css';
import AttendeesList from './components/attendeesList';

export function HomeEventStep({ config, onSubmit = () => {} }) {
    const home = config.home_event_step || config.home_step;
    const {
        orders_list = {},
        waiting_list_tickets = {},
        attendees_list = {},
        ticket_transfer_list = {},
    } = home;

    const miniTabPanes = [{
        value: "tickets",
        label: attendees_list.title,
        icon: "ticket",
        disabled: false
    }];

    if (Object.keys(waiting_list_tickets).length > 0) {
        miniTabPanes.push({
            value: "waiting_lists",
            label: waiting_list_tickets.title,
            icon: "time",
        });
    }

    if (Object.keys(orders_list).length > 0) {
        miniTabPanes.push({
            value: "orders",
            label: orders_list.title,
            icon: "cart",
        });
    }

    const [activeTab, setActiveTab] = React.useState(miniTabPanes[0].value);

    return (
        <div className="wz-home-step">
            <div className="wz-home-step-content">
                <MiniTab panes={miniTabPanes} activeTab={activeTab} onTabSelected={(tab) => setActiveTab(tab.value)}/>
                {activeTab === "tickets" && <AttendeesList config={{attendees_list: attendees_list, ticket_transfer_list: ticket_transfer_list}} onSubmit={onSubmit} />}
                {activeTab === "orders" && <OrderList config={orders_list} onSubmit={onSubmit} />}
                {activeTab === "waiting_lists" && <WaitingTicketsList config={waiting_list_tickets} onSubmit={onSubmit} />}
            </div>
        </div>
    )
}
